import { z } from 'zod';

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml'];

export const EditCustomerSchema = z.object({
    full_name: z.string().min(1, 'The full name field is required.'),
    phone: z
        .string()
        .min(1, 'رقم الهاتف مطلوب')
        .refine((val) => /^\d+$/.test(val), 'الرجاء إدخال أرقام فقط')
        .refine((val) => val.length >= 8 && val.length <= 15, 'يجب أن يتكون رقم الهاتف من 8 إلى 15 رقم'),
    address: z.string().min(1, 'Address is required'),
    national_id: z.string().min(1, 'The personal id number field is required.'),
    driver_license_number: z.string().min(1, 'The driver license number field is required.'),
    national_id_image_front: z
        .instanceof(File, { message: 'Personal ID front image is required.' })
        .refine((file) => file.size <= MAX_FILE_SIZE, `Image must be less than ${MAX_FILE_SIZE}MB`)
        .refine(
            (file) => ALLOWED_FILE_TYPES.includes(file.type),
            'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
        )
        .optional(),
    national_id_image_back: z
        .instanceof(File, { message: 'Personal ID back image is required.' })
        .refine((file) => file.size <= MAX_FILE_SIZE, `Image must be less than ${MAX_FILE_SIZE}MB`)
        .refine(
            (file) => ALLOWED_FILE_TYPES.includes(file.type),
            'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
        )
        .optional(),
    driver_license_img_front: z
        .instanceof(File, { message: 'Driver license front image is required.' })
        .refine((file) => file.size <= MAX_FILE_SIZE, `Image must be less than ${MAX_FILE_SIZE}MB`)
        .refine(
            (file) => ALLOWED_FILE_TYPES.includes(file.type),
            'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
        )
        .optional(),
    driver_license_img_back: z
        .instanceof(File, { message: 'Driver license back image is required.' })
        .refine((file) => file.size <= MAX_FILE_SIZE, `Image must be less than ${MAX_FILE_SIZE}MB`)
        .refine(
            (file) => ALLOWED_FILE_TYPES.includes(file.type),
            'Only .jpeg, .png, .jpg, .gif, and .svg formats are allowed',
        )
        .optional(),
});

export type EditCustomerFormValues = z.infer<typeof EditCustomerSchema>;
